module.exports = __webpack_public_path__ + "static/media/cp3.08197246.glb";